import { Box, Chip, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { formatFileSize } from '@modules/file-preview'

type TAttachmentChipsProps = {
  attachments: File[]
  onRemove: (index: number) => void
}

export const AttachmentChips = ({ attachments, onRemove }: TAttachmentChipsProps) =>
  attachments.length > 0 ? (
    <Box mb={2}>
      <Typography variant="caption" color="text.secondary" display="block" mb={1}>
        Attachments ({attachments.length}):
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {attachments.map((file, index) => (
          <Chip
            key={`${file.name}-${file.size}-${file.lastModified || index}`}
            label={`${file.name} · ${formatFileSize(file.size)}`}
            onDelete={() => onRemove(index)}
            deleteIcon={<CloseIcon />}
            size="small"
            variant="outlined"
          />
        ))}
      </Stack>
    </Box>
  ) : null
